export const timeTracking = () => `
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;

export const subtaskConfiguration = () => `
          subtasks {
            enabled
          }
    `;

export const getJiraSettingsQuery = () => `
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
